import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import Stylesheet from './Metadata.module.css';
import { TableContext } from '../../context/table';
import { QueryContext } from '../../context/query';
import { AppContext } from '../../../../contexts/app';
import { ico_times, ico_bolt, ico_check, ico_sync } from '../../../../icon';
import Button from '../../../../elements/Button/Button';
import { getRecordRange, manualSync } from '../../Table.Engine';

const Metadata = (props) => {
    const [sync, setSync] = useState(false);
    let history = useHistory();
    let table = null;
    let query = null;
    let app = null;
    const init = (tableContext, queryContext, appContext) => {
        table = tableContext;
        query = queryContext;
        app = appContext;
    }
    // get active record set
    const getActiveRecordSet = _ => {
        // search records take priority before all records sets
        if (query.search.records.length > 0) return query.search.records;
        // report records take priority before all records
        else if (query.report.records.length > 0) return query.report.records;
        // use all records
        else return table.records;
    }
    const getTotalRecords = _ => {
        const recordLength = getActiveRecordSet().length;
        const recordLimit = table.filter.recordLimit > recordLength
            ? recordLength : table.filter.recordLimit;
        return <h5 className={Stylesheet.ActiveRecords}>showing {recordLimit}&nbsp;
            {query.report.report ? "report" : null} / {table.records.length} records</h5>;
    }
    const getRecordSelection = _ => {
        if (query.selected.records.length > 0) {
            return (
                <div className={Stylesheet.Selection}>
                    <h6>{query.selected.records.length} records selected</h6>
                    <button onClick={_ =>
                        history.push(`?select=${query.search.length > 0
                            ? "&search=" + query.search : ""}`)}>
                        {ico_times}</button>
                </div>
            )
        }
        return null;
    }
    const getActiveReport = _ => {
        if (query.report.report) {
            return (
                <div className={Stylesheet.ActiveReport}>
                    <h6>report '{query.report.report.title}' active</h6>
                    <button onClick={_ => {
                        // close query
                        query.setReport({ report: null, records: [] });
                        // notify query termination
                        app.toggleToast(ico_bolt, 'report terminated successfully');
                    }}>
                        {ico_times}</button>
                </div>
            )
        }
        return null;
    }
    const performManualSync = async _ => {
        const response = await app.toggleMessageBox("confirm manual sync",
            "This is a critical operation and should not be done often, "
            + "the application monitors and updates data automatically but "
            + "if you are certian this operation is required then continue.", "yes_no");
        if (response === "yes") {
            setSync(true);
            const minRecordRange = getRecordRange(table.filter.min_date, "min");
            const maxRecordRange = getRecordRange(table.filter.max_date, "max");
            // perform manual sync operation
            manualSync(table.config, table.metadata, minRecordRange, maxRecordRange)
            .then(_ => {
                setSync(false);
                app.toggleToast(ico_check, "manual sync complete");
            }, _ => {
                setSync(false);
                app.toggleToast(ico_times, "manual sync failed, check network connection and try again", true);
            })
        } else return;
    }
    const getManualSync = _ => {
        return (
            <div className={Stylesheet.ManualSync}>
                <Button loading={sync} secondary onClick={performManualSync}>{ico_sync} sync</Button>
            </div>
        )
    }
    const content = _ => {
        return (
            <React.Fragment>
                {getTotalRecords()}
                {getRecordSelection()}
                {getActiveReport()}
                {getManualSync()}
            </React.Fragment>
        )
    }

    return (
        <TableContext.Consumer>
            {table => (
                <QueryContext.Consumer>
                    {query => (
                        <AppContext.Consumer>
                            {app => (
                                <div className={Stylesheet.Container}>
                                    {init(table, query, app)}
                                    {content()}
                                </div>
                            )}
                        </AppContext.Consumer>
                    )}
                </QueryContext.Consumer>
            )}
        </TableContext.Consumer>
    )
}

export default Metadata;